export default {
    'welcome-text': 'Bienvenido al sistema de gestión de documentos Acacia',
    'select-company': 'Seleccionar compañía',
}